import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { axiosInstance } from "../../utils/axiosInstance";

export interface DeleteGroupsPayload {
  groupId: number;
}

export const fetchApplicationList = createAsyncThunk(
  "applicationList/fetchData",
  async (params: {
    app_cmdb_id: string[];
    status: string[];
    app_cmdb_name: string[];
    ad_app_guid: string[];
    description: string[];
    primary_contact: string[];
    business_owner: string[];
    feature_names: string[];
    pageNumber: number;
    pageSize: number;
  }) => {
    const response = await axiosInstance.post(
      `/setup/application-details?page_no=${params.pageNumber}&page_size=${params.pageSize}`,
      {
        app_cmdb_id: params?.app_cmdb_id || [],
        status: params?.status || [],
        app_cmdb_name: params?.app_cmdb_name || [],
        ad_app_guid: params?.ad_app_guid || [],
        description: params?.description || [],
        primary_contact: params?.primary_contact || [],
        business_owner: params?.business_owner || [],
        feature_names: params?.feature_names || [],
      },
    );

    return response.data.data;
  },
);

export const deleteGroups = createAsyncThunk<any, DeleteGroupsPayload>(
  "group/DeleteGroups",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/api/groups/${data.groupId}`,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to delete group");
    }
  },
);

export interface ApplicationListDetails {
  id: number;
  status: string;
  app_cmdb_id: string;
  app_cmdb_name: string;
  ad_app_guid: string;
  description: string;
  primary_contact: string;
  business_owner: string;
  feature_names: string[];
}

export type ApplicationList = ApplicationListDetails[];

export type ApplicationListState = {
  data: ApplicationList;
  totalCount: number;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: ApplicationListState = {
  data: [],
  totalCount: 0,
  status: "idle",
  error: null,
};

const applicationListSlice = createSlice({
  name: "applicationList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchApplicationList.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "succeeded";
          state.data = action.payload;
          state.totalCount = action.payload.totalCount;
        },
      )
      .addCase(fetchApplicationList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      });
  },
});

export const selectApplicationList = (state: RootState) =>
  state.applicationList;
export default applicationListSlice.reducer;
